// src/store/tierPickerManagment/reducer.ts

import {
  TierPickerState,
  initialState,
  TierPickerActionTypes,
  OPEN_TIER_PICKER,
  CLOSE_TIER_PICKER,
} from './types';

const tierPickerReducer = (
  state: TierPickerState = initialState,
  action: TierPickerActionTypes
): TierPickerState => {
  switch (action.type) {
    case OPEN_TIER_PICKER:
      return { open: true, ...action.payload };

    case CLOSE_TIER_PICKER:
      return initialState;

    default:
      return state;
  }
};

export default tierPickerReducer;
